import { render, staticRenderFns } from "./BasketItems.vue?vue&type=template&id=426a23cc&scoped=true&"
import script from "./BasketItems.vue?vue&type=script&lang=js&"
export * from "./BasketItems.vue?vue&type=script&lang=js&"
import style0 from "./BasketItems.vue?vue&type=style&index=0&id=426a23cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a23cc",
  null
  
)

export default component.exports